module.exports = __webpack_public_path__ + "static/media/vinefinder-codesnippet1.d2cc251b.png";